﻿var Base = (function () {

    function select(selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector));
    }

    function selectAllClasses(selector) {
        return document.querySelectorAll('.' + selector);
    }

    function get(selector) {
        return document.querySelector(selector);
    }

    function getAll(elem) {
        return Array.from(document.querySelectorAll(elem));
    }

    function hasClass(element, cls) {
        return element.classList.contains(cls);
    }

    function addClass(element, cls) {
        if (element != null) { element.classList.add(cls); }
    }

    function removeClass(element, cls) {
        if (element != null) { element.classList.remove(cls); }
    }

    function toggleClass(elem, cls) {
        if (!elem) { throw new Error('Requires element'); }
        if (!cls) { throw new Error('Requires class name'); }
        elem.classList.toggle(cls);
    }

    function findClosest(elem, cls) {
        while ((elem = elem.parentElement) && !elem.classList.contains(cls));
        return elem;
    }

    function findChild(elem, selector) {
        if (!elem) { throw new Error('Requires element'); }
        if (!selector) { throw new Error('Requires selector'); }
        if (elem.querySelector(selector)) {
            return elem.querySelector(selector);
        } else {
            throw new Error('Child element "' + selector + '" does not exist in parent');
        }
    }

    function pageHasSelector() {
        const fn = arguments[0];
        if (typeof (fn) != 'function') { throw new Error('Requires action'); }

        for (let i = 1; i < arguments.length; i++) {
            if (document.querySelector(arguments[i])) { return fn(); }
        }
    }

    function debounce(func, wait, immediate) {
        let timeout;
        return function () {
            const context = this, args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    function propagateUpLink(elem) {
        if (!elem) { throw new Error('Requires element'); }
        if (elem.tagName != 'A' && elem.parentNode.tagName == 'A') {
            elem = elem.parentNode;
        }
        return elem;
    }
    return {
        get: get,
        getAll: getAll,
        select: select,
        hasClass: hasClass,
        addClass: addClass,
        debounce: debounce,
        findChild: findChild,
        removeClass: removeClass,
        toggleClass: toggleClass,
        findClosest: findClosest,
        pageHasSelector: pageHasSelector,
        selectAllClasses: selectAllClasses,
        propagateUpLink: propagateUpLink
    };
}());

export default Base;

